import { render, staticRenderFns } from "./DownloadDialog.vue?vue&type=template&id=6b7c5ffe&scoped=true"
import script from "./DownloadDialog.vue?vue&type=script&lang=js"
export * from "./DownloadDialog.vue?vue&type=script&lang=js"
import style0 from "./DownloadDialog.vue?vue&type=style&index=0&id=6b7c5ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7c5ffe",
  null
  
)

export default component.exports